const ROLES = [
  {
    name: 'Super Admin',
    key: 'ROLE_SUPER_ADMIN',
    access: 1
  },
  {
    name: 'Admin',
    key: 'ROLE_ADMIN',
    access: 2
  },
  {
    name: 'User',
    key: 'ROLE_USER',
    access: 3
  }
];

export default ROLES;
